import React, { useContext } from "react";
import styled from "styled-components";
import { H5, P } from "../Texts";
import { themeContext } from "../../../shared/store/contexts";

const LandingPageCardStyle = styled.div``;

export const LandingPageCard = ({
  description,
  img,
  alt,
  title,
  width,
  classname,
}) => {
  const { theme } = useContext(themeContext);

  return (
    <LandingPageCardStyle width={width} className={classname}>
      <div className="flex flex-col items-center justify-center">
        <img src={img} alt={alt} className="h-10 w-12 mr-4" />

        <div className="flex flex-col mt-5">
          <H5
            color={theme.darkFont}
            fontSize="20px"
            smallSize="16px"
            className="mb-0 text-center font-semibold truncate"
          >
            {title}
          </H5>
          <P
            color={theme.ashFont}
            fontSize="16px"
            className="text-center font-normal mt-2"
          >
            {description}
          </P>
        </div>
      </div>
    </LandingPageCardStyle>
  );
};
